import { SsrService } from '@/common/services/ssr/ssr.service';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'fe-rental-requirements',
    templateUrl: './rental-requirements.component.html',
    styleUrls: ['./rental-requirements.component.scss'],
})
export class RentalRequirementsComponent {
    @Input() opened = true;

    constructor(private readonly ssr: SsrService) {}

    public toggle(): void {
        this.opened = !this.opened;
    }

    public scrollToPolicies(event: Event): void {
        event.preventDefault();

        if (this.ssr.isPlatformServer()) {
            return;
        }

        document
            .getElementById('rental-policies')
            ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}
